import { useNavigate } from 'react-router'
import { Gavel } from 'lucide-react'
import { Badge, Card, Empty, PageHeader, Table, type Column } from '@concours/ui'
import { useGradingStages, type GradingStage } from '../../lib/grading'
import { Progress } from './Progress'

/** Commission : étapes dont la notation est ouverte (ou close), dans le périmètre. */
export function CommissionsPage() {
  const navigate = useNavigate()
  const stages = useGradingStages()
  const columns: Column<GradingStage>[] = [
    {
      key: 'competition',
      header: 'Concours',
      cell: (s) => (
        <span className="stack" style={{ gap: 2 }}>
          <strong>{s.competition.title}</strong>
          <span className="mono muted">{s.competition.reference}</span>
        </span>
      ),
    },
    { key: 'stage', header: 'Étape', cell: (s) => `${s.position}. ${s.label}` },
    {
      key: 'progress',
      header: 'Relevés validés',
      cell: (s) => (
        <Progress
          done={s.sheets.validated}
          total={s.sheets.total}
          label={`Relevés validés — ${s.label}`}
        />
      ),
    },
    {
      key: 'submitted',
      header: 'À valider',
      numeric: true,
      cell: (s) => (s.sheets.submitted ? <Badge variant="info">{s.sheets.submitted}</Badge> : '—'),
    },
    {
      key: 'status',
      header: 'État',
      cell: (s) => (
        <Badge variant={s.status === 'grading' ? 'warning' : 'success'}>{s.statusLabel}</Badge>
      ),
    },
  ]
  return (
    <>
      <PageHeader
        eyebrow="Notes"
        title="Commissions et notes"
        description="Constituez les lots, affectez les évaluateurs, suivez la saisie, traitez les anomalies et validez les relevés. Seules les étapes dont les barèmes sont verrouillés apparaissent ici."
      />
      <Card>
        <Table
          columns={columns}
          rows={stages.data ?? []}
          rowKey={(s) => s.id}
          loading={stages.isPending}
          caption="Étapes en notation"
          onRowClick={(s) => navigate(`/commissions/${s.id}`)}
          empty={
            <Empty
              icon={<Gavel aria-hidden="true" />}
              title="Aucune étape en notation"
              description="Une étape apparaît ici une fois ses barèmes verrouillés (« Étapes et barèmes »)."
            />
          }
        />
      </Card>
    </>
  )
}
